import "./styles.scss";
import { ContactSupportLinks } from "@src/appV2/support/types";
import { Agent } from "@src/lib/interface/src";

import { IcAgreementHelpText } from "../../../../appV2/IcAgreement/IcAgreementHelpText";

export interface SignAgreementErrorProps {
  agent: Agent;
  providedName: string;
  contactSupportLinks: ContactSupportLinks;
}

export function SignAgreementError(props: SignAgreementErrorProps) {
  const {
    providedName,
    contactSupportLinks,
    agent: { name: workerName },
    agent,
  } = props;

  return (
    <div className="ic-agreement-error-message-container">
      Please sign by typing your name as shown on this page
      <br />
      Accepted signature: {workerName}
      {providedName ? (
        <>
          <br />
          You typed: {providedName}
        </>
      ) : (
        <></>
      )}
      <br />
      <br />
      <IcAgreementHelpText contactSupportLinks={contactSupportLinks} agent={agent} />
    </div>
  );
}
